<template>
  <div class="login-wrap">
    <img
      class="login-top-bg"
      src="../assets/images/dashboard-top-bg.jpg"
    />
    <div class="login-header">
      <div class="login-header-head">
        <img src="../assets/images/head.png" />
      </div>
      <div class="login-header-body">
        <div class="login-header-name" @click="doLogin">
          <span>授权登录</span>
        </div>
      </div>
    </div>
     <!-- 未申请为企业 -->
     <div
      class="dashboard-banner"
      @click="changePage('map')"
    ></div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useStore } from "vuex";
import router from '@/router';
import { showFailToast,Empty,Button } from 'vant';
import { login } from '@/service/api';
import { getRouteQuery } from '@/hooks/usePage';
const { code, redirect = '/' } = getRouteQuery();

const store = useStore();

const doLogin = () => {
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5382d6c7855b78db&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
}

const changePage = (url) => {
  router.push(url);
};

onMounted(() => {
  if (store.getters.hasLogin) {
    router.push(redirect);
    return;
  }
  if (code) {
    login({ code }).then((res) => {
      if(res.oauth2AccessToken){
        localStorage.setItem('token', `Bearer ${res.oauth2AccessToken.access_token}`);
        router.push(redirect);
      }
    }).catch((err) => {
      showFailToast(err);
    })
  }
})
</script>

<style lang="scss" scoped>
.login-wrap {
  width: 100%;
  height: 100%;
  background: #f3f5f9;
  position: relative;
  box-sizing: border-box;
  padding: 30px 16px;
  position: relative;
  height: 100%;
}

.login-top-bg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.login-header {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  padding: 0 30px 0 16px;

  &-head {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    margin-right: 10px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &-body {
    position: relative;
    flex: 1;
  }

  &-name {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.dashboard-banner {
  position: relative;
  margin-top: 60px;
  width: 100%;
  height: 103px;
  background-image: url("~@/assets/images/banner-map.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 12px;
  &-two {
    position: relative;
    margin-top: 15px;
    width: 100%;
    height: 103px;
    background-image: url("~@/assets/images/banner-join.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 12px;
  }
}
</style>